import React from "react";
import { Route } from "react-router-dom";
import {
  AuthenticatedApp,
  AuthenticatedSwitch,
  PrivateRoute,
  PublicRoute,
  NavigationLogger,
  ResponsiveScreen,
} from "@redriver/cinnamon";
import { EnvironmentBanner } from "components/banners";
import { AppRoutes, SystemRoutes } from "constants/routes";
import LoginPage from "./system/LoginPage";
import LogoutPage from "./system/LogoutPage";
import RepPortal from "./RepPortal";
import { NetworkChecker } from "components/NetworkChecker";
import "styles/index.scss";
import ResetPasswordPage from "./system/ResetPasswordPage";
import ForgottenPasswordPage from "./system/ForgottenPasswordPage";

/**
 * Top-level app routes only
 * Define sub-path routes inside top-level page components
 */
const Shell = () => (
  <AuthenticatedApp>
    <NavigationLogger />
    <ResponsiveScreen />
    <EnvironmentBanner />
    <NetworkChecker />
    <AuthenticatedSwitch>
      {/* system routes */}
      <Route exact path={SystemRoutes.Login} component={LoginPage} />
      <Route exact path={SystemRoutes.Logout} component={LogoutPage} />
      <Route
        exact
        path={SystemRoutes.ResetPassword}
        component={ResetPasswordPage}
      />
      <Route
        exact
        path={SystemRoutes.ForgottenPassword}
        component={ForgottenPasswordPage}
      />

      {/* app routes */}
      <PrivateRoute component={RepPortal} redirect={SystemRoutes.Login} />
    </AuthenticatedSwitch>
  </AuthenticatedApp>
);

export default Shell;
